class MainHeader extends HTMLElement {
  constructor() {
    super();

    this.header = this.querySelector("header");

    this.bodyContent = document.querySelector("#MainContent");

    // Set initial margin
    this.updateMarginTop();

    // Create observer to watch for iframe additions
    this.observer = new MutationObserver(this.handleDOMChanges.bind(this));
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Nav Links
    this.onNavClick = this.handleNavClick.bind(this);

    this.navLinks = this.querySelectorAll(".nav-link.has-submenu");
    this.flyoutMenus = this.querySelectorAll(".js-flyout-menu");

    this.navLinks.forEach((link) => {
      // console.log("link", link);
      link.addEventListener("click", this.onNavClick);
    });
  }

  updateMarginTop() {
    const intercomBanner = document.querySelector(
      "iframe[name='intercom-banner-frame']",
    );
    const extraMargin = intercomBanner ? 48 : 0;

    // Update body content margin
    this.bodyContent.style.marginTop =
      this.header.clientHeight + extraMargin + "px";

    // Update header position
    this.header.style.top = extraMargin + "px";
  }

  handleDOMChanges(mutations) {
    for (const mutation of mutations) {
      // Check for added nodes
      if (mutation.addedNodes.length > 0) {
        const hasIntercomFrame = Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeName === "IFRAME" && node.name === "intercom-banner-frame",
        );

        if (hasIntercomFrame) {
          this.updateMarginTop();
          break;
        }
      }

      // Check for removed nodes
      if (mutation.removedNodes.length > 0) {
        const hadIntercomFrame = Array.from(mutation.removedNodes).some(
          (node) =>
            node.nodeName === "IFRAME" && node.name === "intercom-banner-frame",
        );

        if (hadIntercomFrame) {
          this.updateMarginTop();
          break;
        }
      }
    }
  }

  closeFlyoutMenus() {
    this.flyoutMenus.forEach((menu) => {
      menu.classList.remove("flyout-menu-open");
      menu.classList.add("flyout-menu-close");
    });
  }

  handleNavClick(evt) {
    const btn = evt.target;

    const menu = this.querySelector(`#flyout-menu-${btn.dataset.handle}`);
    if (!menu.classList.contains("flyout-menu-open")) {
      this.closeFlyoutMenus();
      menu.classList.add("flyout-menu-open");
    } else {
      this.closeFlyoutMenus();
    }
  }
}

customElements.define("main-header", MainHeader);
